const OBJECT_ID_PATTERN = /^[a-f\d]{24}$/i;

export const getReceivingTimeTimestamp = (item) => {
  const raw =
    item?.requestReceivingTime ||
    item?.receivedAt ||
    item?.requestedAt ||
    item?.submittedAt ||
    item?.createdAt ||
    item?.nursingRequest?.requestReceivingTime ||
    item?.nursingRequest?.createdAt;

  if (raw) {
    const timestamp = new Date(raw).getTime();
    if (!Number.isNaN(timestamp)) return timestamp;
  }

  const id = item?._id || item?.nursingRequest?._id;
  if (OBJECT_ID_PATTERN.test(id || "")) {
    return parseInt(id.slice(0, 8), 16) * 1000;
  }

  return 0;
};

export const sortByReceivingTimeDesc = (items = []) =>
  [...items].sort((a, b) => getReceivingTimeTimestamp(b) - getReceivingTimeTimestamp(a));

export const matchesRequestSearch = (item, query) => {
  const q = query.trim().toLowerCase();
  if (!q) return true;

  const reqId = (item.nursingRequestID || item._id || "").toLowerCase();
  const hn = (item.hnNumber || item.hn || item.patient?.hnNumber || "").toLowerCase();
  const rel = item.relativeInfo;
  const relName = rel ? `${rel.firstName || ""} ${rel.lastName || ""}`.toLowerCase() : "";
  const patName = (item.patient?.fullName || "").toLowerCase();

  return reqId.includes(q) || hn.includes(q) || relName.includes(q) || patName.includes(q);
};
